import Vue from "vue";
import Component from "vue-class-component";
import DatePicker from "@/components/Util/DatePicker/DatePicker.vue";
import moment from "moment";
import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";

const ClinicResultSubheaderProps = Vue.extend({
  props: {
    selectedServiceDefaultName: {
      type: [Object as () => ServiceDefaultNameInterface],
      default: null,
    },
  },
});
@Component<ClinicResultSubheader>({
  name: "ClinicResultSubheader",
  components: {
    'date-picker': DatePicker,
  },
  watch: {
    showDatePicker(display) {
      if (display) {
        document.querySelector(".date-picker-trigger")?.classList.add("overwrited-hover");
      } else {
        document.querySelector(".date-picker-trigger")?.classList.remove("overwrited-hover");
      }
    }
  }
})

export default class ClinicResultSubheader extends ClinicResultSubheaderProps {
  showDatePicker = false;
  currentDate = moment(new Date()).locale("pt").format("dddd DD [de] MMMM YYYY");
  selectedFormattedDate = "";

  displayDatePicker(): void {
    this.showDatePicker = !this.showDatePicker;
  }

  selectedDate(date: string): void {
    this.selectedFormattedDate = date;
    this.showDatePicker = false;
  }
}